












import { Component, Prop, Vue } from 'vue-property-decorator';
import UserIcon from '@/components/global/UserIcon.vue';
import UserName from '@/components/global/UserName.vue';

@Component({
  components: {
    UserIcon,
    UserName,
  },
})
export default class UserStatus extends Vue {
  @Prop({ required: true }) name!: string;
  @Prop({ default: null, type: String }) rank!: string | null;
  @Prop({ default: null, type: Boolean }) online!: string | null;

  get dispOnlineStats() {
    return this.online != null;
  }

  toUserProfile(name: string) {
    if (this.$route.name !== 'User') this.$router.push({ name: 'User', params: { userId: name } });
    else if (this.$route.params.userId !== name) {
      this.$router.push({ name: 'User', params: { userId: name } });
    }
  }
}
